<mg-simple-form *ngIf="form" [formGroup]="form" [errorMessage]="errorMessage" label="Bericht" title="{{item?.title}}" (onSubmit)="onSubmit($event)" (onDelete)="onDelete()" [customActions]="customActions" [dtoClassName]="dtoTypeName">
              
   <mg-simple-form-section title="Algemeen">
        
        <mg-simple-form-row>
            <span>
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerDate" placeholder="Start Bericht" formControlName="date">
                    <mat-datepicker-toggle matSuffix [for]="pickerDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerDate></mat-datepicker>
                    <mat-error>{{getError('date')}}</mat-error>
                </mat-form-field>
            </span>
            <span>
                <mat-form-field>
                    <input matInput [matDatepicker]="pickerExpiringDate" placeholder="Einde Bericht" formControlName="expiringDate">
                    <mat-datepicker-toggle matSuffix [for]="pickerExpiringDate"></mat-datepicker-toggle>
                    <mat-datepicker #pickerExpiringDate></mat-datepicker>
                    <mat-error>{{getError('expiringDate')}}</mat-error>
                </mat-form-field>
            </span>
            <span>
                <mat-form-field>
                    <mat-select formControlName="type" placeholder="Type">
                        <mat-option *ngFor="let item of alertType | enum" [value]="item.value">{{item.name}}</mat-option>
                    </mat-select>
                    <mat-error>{{getError('type')}}</mat-error>
                </mat-form-field>
            </span>
        </mg-simple-form-row>

        <mg-simple-form-row>
            <span mg-colspan-2>
                <mat-form-field pd-size-32>
                    <input type="text" placeholder="Titel" matInput formControlName="title">
                    <mat-error>{{form.mgErrors.title}}</mat-error>
                </mat-form-field>
            </span>
        </mg-simple-form-row>

        <br>
        <hr style="opacity: 0.2;">
        <br>
        
        <mg-simple-form-row>
            <span mg-colspan-3>
                <mat-form-field pd-size-max>
                    <textarea cdkTextareaAutosize type="text" placeholder="Bericht" matInput formControlName="message" class="TextareaLineHeight"></textarea> 
                    <mat-error>{{getError('message')}}</mat-error>
                </mat-form-field>
            </span>
            
        </mg-simple-form-row>


   </mg-simple-form-section>


</mg-simple-form>